var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RateTip = RateTip;
exports.setRatingStorage = exports["default"] = exports.RatingComponent = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRating = _interopRequireDefault(require("react-rating"));
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _lurker = require("../../helpers/lurker");
var _SingleTip = require("./SingleTip");
var _StepsTip = require("./StepsTip");
var _isMobile = require("../../helpers/isMobile");
var _jsxRuntime = require("react/jsx-runtime");
var _this = this,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/RateTip/index.js";
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var setRatingStorage = function setRatingStorage(_ref) {
  var securityRating = _ref.securityRating,
    fastResponseRating = _ref.fastResponseRating,
    cordialityRating = _ref.cordialityRating,
    chatId = _ref.chatId;
  localStorage.setItem("".concat(chatId, "-rating-tip"), JSON.stringify({
    securityRating: securityRating,
    fastResponseRating: fastResponseRating,
    cordialityRating: cordialityRating
  }));
};
exports.setRatingStorage = setRatingStorage;
var RatingComponent = function RatingComponent(_ref2) {
  var onChange = _ref2.onChange,
    title = _ref2.title,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$initialValue = _ref2.initialValue,
    initialValue = _ref2$initialValue === void 0 ? 0 : _ref2$initialValue,
    _ref2$leftRating = _ref2.leftRating,
    leftRating = _ref2$leftRating === void 0 ? false : _ref2$leftRating;
  var onChangeRating = function onChangeRating(rate) {
    setRating(rate);
    onChange(rate);
  };
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var isMsite = (0, _isMobile.isMobile)();
  var leftRatingStyle = {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '--spacing-1'
  };
  var normalRatingStyle = {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  };
  var TextComponent = isMsite ? _dsWeb.Text.BodySmall : _dsWeb.Text.BodyMedium;
  var marginTop = isMsite ? '--spacing-1' : '--spacing-2';
  var marginLeft = isMsite ? '--spacing-1' : '--spacing-2';
  return (0, _jsxRuntime.jsxs)(_dsWeb.Flex, Object.assign({}, leftRating ? leftRatingStyle : normalRatingStyle, {
    children: [(0, _jsxRuntime.jsx)(TextComponent, {
      marginTop: !leftRating && marginTop,
      marginLeft: leftRating && marginLeft,
      children: title
    }), (0, _jsxRuntime.jsx)(_reactRating["default"], {
      start: 0,
      stop: 5,
      readonly: disabled,
      style: {
        maxWidth: 160
      },
      initialRating: rating,
      onChange: onChangeRating,
      emptySymbol: (0, _jsxRuntime.jsx)(_dsIcons.Star, {
        color: "var(--color-feedback-attention-100)"
      }),
      fullSymbol: (0, _jsxRuntime.jsx)(_dsIcons.StarFilled, {
        color: "var(--color-feedback-attention-100)"
      })
    })]
  }));
};
exports.RatingComponent = RatingComponent;
function RateTip(_ref3) {
  var textVariant = _ref3.textVariant,
    chatId = _ref3.chatId,
    accountId = _ref3.accountId,
    _ref3$partnerName = _ref3.partnerName,
    partnerName = _ref3$partnerName === void 0 ? 'essa pessoa' : _ref3$partnerName,
    _ref3$userName = _ref3.userName,
    userName = _ref3$userName === void 0 ? "Você" : _ref3$userName;
  var ratingData = JSON.parse(localStorage.getItem("".concat(chatId, "-rating-tip")));
  var securityRating = 0;
  var fastResponseRating = 0;
  var cordialityRating = 0;
  (0, _react.useEffect)(function () {
    (0, _lurker.viewTipRating)({
      chat_id: chatId,
      accountId: accountId
    });
  }, [chatId, accountId]);
  if (ratingData) {
    securityRating = ratingData['securityRating'];
    fastResponseRating = ratingData['fastResponseRating'];
    cordialityRating = ratingData['cordialityRating'];
  }
  if (textVariant === 'single' || textVariant === 'v3') {
    return (0, _jsxRuntime.jsx)(_SingleTip.SingleTip, {
      chatId: chatId,
      accountId: accountId,
      securityStorage: securityRating,
      cordialityStorage: cordialityRating,
      partnerName: partnerName,
      userName: userName,
      variant: textVariant
    });
  } else if (textVariant === 'steps') {
    return (0, _jsxRuntime.jsx)(_StepsTip.StepsTip, {
      chatId: chatId,
      accountId: accountId,
      securityStorage: securityRating,
      fastResponseStorage: fastResponseRating,
      partnerName: partnerName
    });
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
}
var _default = RateTip;
exports["default"] = _default;